import { Model, type ModelProps } from '@/infra/model'
import { observable } from 'mobx'
import { Workspace } from '@/features/iam/workspaces/Workspace'
import { Id } from '@/infra/id'

export type WorkspaceWithBundlesProps = ModelProps<WorkspaceWithBundles>

export class WorkspaceWithBundles extends Model<WorkspaceWithBundles> {
  id = Id.none

  @observable accessor workspace: Workspace = Workspace.none
}
